import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { PaginationService } from 'src/app/PaginationService';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { qmsService } from '../qms.service';
import { Component, ViewChild, TemplateRef, EventEmitter, Output, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-parallel-workflows',
  templateUrl: './add-parallel-workflows.component.html',
  styleUrls: ['./add-parallel-workflows.component.scss']
})
export class AddParallelWorkflowsComponent implements OnInit {

  isProcessing: boolean = false;
  @Output() valueEmitter = new EventEmitter<string>();
  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, public qmsservice: qmsService,) {
    this.message.breadcrumbData.fourthLevel = null;
  };

  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  addAndEditPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  qualityGroup: any = {};
  popupTitle: any;
  ngOnInit(): void {
    this.popupTitle = "Create Parallel Workflow";
    this.qualityGroup = { reasonForWorkflow: '' };
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  openAddPopup() {
    this.popupTitle = "Create Quality Group";
    this.qualityGroup = {};
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
    const field = document.getElementById('justification-validation') as HTMLInputElement;
    field.style.color = '#005c8a'
  };

  handleDropDownValidation(fieldId: string, selectedItems: any) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    if (field != null)
      field.style.color = (selectedItems === null || selectedItems == '') && field ? 'red' : '#005c8a';
  }

  addAndEditFunction() {
    if (this.qualityGroup.reasonForWorkflow == '') {
      this.handleDropDownValidation('justification-validation', this.qualityGroup.reasonForWorkflow);
      this.showSnackBar("Please enter justification for parallel workflow", "E");
    } else {
      this.isProcessing = true;

      const add_obj = {
        refNo: this.qmsservice.activityId,
        module: this.qmsservice.moduleName,
        reasonForWorkflow: this.qualityGroup.reasonForWorkflow,
      }

      this.appService.createParallelWorkflow(add_obj).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.valueEmitter.emit();
            this.visibleAddAndEditPopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel
          ? this.message.breadcrumbData.thirdLevel
          : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  };
  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
    this.valueEmitter.emit();
  };
}
